const PW = "pay8899"

export {PW}